// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { OrderModel, OrderSettingsModel } from "@insite/client-framework/Types/ApiModels";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { connect } from "react-redux";

// Absolunet Custom Code --->
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";

import useCanSeePrices from "@store/Framework/Store/Data/Accounts/Hooks/useCanSeePrices";
import StoreOrderStatus from "@store/Library/Components/Foundation/StoreOrder/StoreOrderStatus";
import { historyTableProps } from "@store/Themes/common/props/history";
import { css } from "styled-components";
// <--- Absolunet Custom Code

const mapStateToProps = (state: ApplicationState) => ({
    language: state.context.session.language,
});

interface OwnProps {
    order: OrderModel;
    orderSettings: OrderSettingsModel;
    extendedStyles?: OrderSummaryCardStyles;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface OrderSummaryCardStyles {
    orderSummaryCardGridItem?: GridItemProps;
    container?: GridContainerProps;
    pageTypeLinkGridItem?: GridItemProps;
    orderNumberGridItem?: GridItemProps;
    orderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    statusGridItem?: GridItemProps;
    statusHeadingAndText?: SmallHeadingAndTextStyles;
    webOrderNumberGridItem?: GridItemProps;
    webOrderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    totalGridItem?: GridItemProps;
    totalHeadingAndText?: SmallHeadingAndTextStyles;
    // Valtech Custom Code
    orderNumberCell?: DataTableCellProps;
    dateCell?: DataTableCellProps;
    shipToCell?: DataTableCellProps;
    customerPOCell?: DataTableCellProps;
    statusCell?: DataTableCellProps;
    totalCell?: DataTableCellProps;
    // Foundation
    cellOrderStatus?: DataTableCellBaseProps;
}

export const orderSummaryCardStyles: OrderSummaryCardStyles = {
    orderNumberCell: historyTableProps.orderNumberCell,
    dateCell: historyTableProps.dateCell,
    shipToCell: historyTableProps.shipToCell,
    customerPOCell: historyTableProps.customerPOCell,
    statusCell: historyTableProps.statusCell,
    totalCell: historyTableProps.totalCell,
};

const OrderSummaryCard: FC<Props> = ({ language, order, orderSettings, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(orderSummaryCardStyles, extendedStyles));

    // Absolunet Custom Code --->
    const canSeePrices = useCanSeePrices();
    // <--- Absolunet Custom Code

    const orderDateDisplay = getLocalizedDateTime({
        dateTime: order.orderDate,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });

    /* Valtech Custom Code */
    const orderNumber = orderSettings.showWebOrderNumber
        ? order.webOrderNumber || order.erpOrderNumber
        : order.erpOrderNumber || order.webOrderNumber;

    const shipTo = `${order.stCompanyName} ${order.stAddress1} ${order.stAddress2} ${order.shipToCity} ${order.shipToState}`;

    return (
        // Bunzl Custom Code custom compact recent orders --->
        <DataTableRow key={order.id}>
            <DataTableCell>
                {orderNumber ? <OrderDetailPageTypeLink title={orderNumber} orderNumber={orderNumber} /> : "--"}
            </DataTableCell>
            <DataTableCell>{order.btCompanyName ? order.btCompanyName : "--"}</DataTableCell>
            <DataTableCell>{orderDateDisplay}</DataTableCell>
            {canSeePrices && <DataTableCell>{order.orderGrandTotalDisplay}</DataTableCell>}
            <DataTableCell {...styles.cellOrderStatus}>
                <StoreOrderStatus status={order.statusDisplay} />
            </DataTableCell>
        </DataTableRow>
        // <--- Bunzl Custom Code
    );
};

export default connect(mapStateToProps)(OrderSummaryCard);
